// https://github.com/facebook/jest/issues/9239
export const sanitizeBreakingSpaces = (value: string) => {
	const WHITE_SPACE = " ";
	return value.replace(/\xa0/g, WHITE_SPACE).replace(/\u202f/g, WHITE_SPACE);
};
